import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEnMobile from '../../locales/en-mobile/translation.json';
import translationEn from '../../locales/en/translation.json';
import translationKoMobile from '../../locales/ko-mobile/translation.json';
import translationKo from '../../locales/ko/translation.json';
import translationZhMobile from '../../locales/zh-mobile/translation.json';
import translationZh from '../../locales/zh/translation.json';

const isMobile = () => window.innerWidth <= 1439;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      resources: {
        ko: { translation: translationKo },
        'ko-mobile': { translation: translationKoMobile },
        en: { translation: translationEn },
        'en-mobile': { translation: translationEnMobile },
        zh: { translation: translationZh },
        'zh-mobile': { translation: translationZhMobile },
      },
      fallbackLng: 'ko',
      supportedLngs: ['ko','ko-mobile','en','en-mobile','zh','zh-mobile'],
      load: 'currentOnly', // 'en-US' → 'en' 식으로 정규화
      detection: {
        order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
        caches: ['cookie', 'localStorage'],
        lookupCookie: 'i18next', // 기본값이기도 함
      },
      interpolation: { escapeValue: false },
      // ❌ lng는 지정하지 않습니다.
    },
    () => {
      // 여기서 "모바일이면 -mobile" 변형만 적용
      const isMobile = () => window.innerWidth <= 1439;
      const base = i18n.resolvedLanguage?.split('-')[0] || 'ko';
      const target = isMobile() ? `${base}-mobile` : base;
      if (i18n.language !== target) i18n.changeLanguage(target);
    }
  );

export default i18n;
